import React, { useState, useEffect } from 'react';
import {
  auth,
  db,
  provider
} from '../../firebaseConfig';
import {
  signInWithPopup,
  signOut,
  onAuthStateChanged,
  setPersistence,
  browserSessionPersistence
} from 'firebase/auth';
import {
  collection,
  addDoc,
  onSnapshot,
  serverTimestamp,
  query,
  orderBy
} from 'firebase/firestore';
import './Review.css';

const ReviewComponent = () => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState('');
  const [reviews, setReviews] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    const q = query(collection(db, 'reviews'), orderBy('timestamp', 'desc'));
    const unsubscribeReviews = onSnapshot(q, (snapshot) => {
      const loaded = snapshot.docs.map(doc => doc.data());
      setReviews(loaded);
    });

    return () => {
      unsubscribeAuth();
      unsubscribeReviews();
    };
  }, []);

  const login = () => {
    setPersistence(auth, browserSessionPersistence)
      .then(() => signInWithPopup(auth, provider))
      .catch((error) => {
        console.error("Login failed:", error.message);
      });
  };

  const logout = () => {
    signOut(auth)
      .then(() => {
        localStorage.clear();
        sessionStorage.clear();
      })
      .catch((error) => {
        console.error("Logout failed:", error.message);
      });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return alert("Please log in to submit a review.");
    if (!rating || !comment.trim()) return;

    await addDoc(collection(db, 'reviews'), {
      rating,
      comment: comment.trim(),
      timestamp: serverTimestamp(),
      user: {
        name: user.displayName,
        uid: user.uid
      }
    });

    setRating(0);
    setHover(0);
    setComment('');
  };

  return (
    <div className="container-fluid review-container">
      <h3 className="mb-3 text-light mt-5">Leave a Review</h3>

      {user ? (
        <>
          <p className="mb-2">
            Welcome, {user.displayName}
            <button
              onClick={logout}
              className="btn btn-sm btn-outline-secondary ms-2"
            >
              Logout
            </button>
          </p>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  type="button"
                  key={star}
                  className="btn btn-link p-0 me-1"
                  onClick={() => setRating(star)}
                  onMouseEnter={() => setHover(star)}
                  onMouseLeave={() => setHover(0)}
                  style={{
                    color: (hover || rating) >= star ? '#ffc107' : '#e4e5e9',
                    fontSize: '1.5rem',
                    textDecoration: 'none'
                  }}
                >
                  ★
                </button>
              ))}
            </div>
            <div className="mb-3">
              <textarea
                className="form-control"
                rows="3"
                placeholder="Write your comment here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-primary">Submit Review</button>
          </form>
        </>
      ) : (
        <div className="text-center">
          <button className="btn btn-primary m-auto" onClick={login}>
            Login
          </button>
        </div>
      )}

      {reviews.length > 0 && (
        <div className="mt-4">
          <h4>Reviews</h4>
          {reviews.map((r, i) => (
            <div key={i} className="review-card">
              <div className="mb-1 text-warning">
                {'★'.repeat(r.rating)}{'☆'.repeat(5 - r.rating)}
              </div>
              <p className="mb-1">{r.comment}</p>
              {r.user?.name && (
                <small className="text-muted">– {r.user.name}</small>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReviewComponent;
